module.exports = __webpack_public_path__ + "static/jack-d08e67cb2d473a963e60da7b5d8d32c7.png";